import {Display} from "./Display";
import {Browser} from "./Browser";
import {Basic} from "./Basic";

export class Slider
{
    constructor(moveEl, i)
    {
        this.parentEl = moveEl.closest('.module,.lightbox-gallery-container');
        this.moveEl = moveEl;
        this.moveEl.dataset.sliderNo = i.toString();

        this.slides = this.moveEl.querySelectorAll('.slider-item');
        this.slideCount = this.slides.length;
        this.activeSlide = this.slides[0];
        this.activeSlide.classList.add('active');
        this.activeSlideNo = 1;

        this.sliderNav = '';
        this.autoscroll = false;
        this.autoscrollDirection = 'next';
        this.autoscrollDelay = 5000;
        this.moving = false;
        this.moveEl.classList.add('processed');
        this.moveEl.style.transform = 'translateX(0)';
        this.moveEl.offsetHeight;

        if(this.slideCount > 1)
        {
            if(this.moveEl.querySelector('.slider-item:last-child').getBoundingClientRect()['left'] +
               this.moveEl.querySelector('.slider-item:last-child').getBoundingClientRect()['width'] > Display.x)
            {
                this.moveEl.classList.add('autoscroll-slider');
            }

            this.addNavigation();

            if(Browser.touchscreen)
            {
                this.addTouchEvents();
            }
        }
    }

    addNavigation()
    {
        let i = 1;

        this.sliderNav = document.createElement('ul');
        this.sliderNav.classList.add('slider-nav-ul');
        this.sliderNav.addEventListener('click', e =>
        {
            const el = e.target;
            if(el.tagName.toLowerCase() === 'li' &&
              !el.classList.contains('active'))
            {
                this.move(e, el);
            }
        });

        this.slides.forEach(el =>
        {
            el.dataset.no = i.toString();
            el.classList.add('processed');
            el.offsetHeight;

            const myLi = document.createElement('li'),
                  myLiNo = '0' + i.toString();
            myLi.textContent = myLiNo.substring(myLiNo.length - 2);
            myLi.dataset.no = i.toString();

            if(i === 1)
            {
                myLi.classList.add('active');
            }

            this.sliderNav.appendChild(myLi);
            i++
        });

        this.moveEl.addEventListener('click', e =>
        {
            let el = e.target;

            if(el.closest('.slider-item'))
            {
                el = el.closest('.slider-item');
            }

            if(el.classList.contains('slider-item') &&
              !el.classList.contains('active'))
            {
                this.move(e, el);
            }
        });

        this.parentEl.appendChild(this.sliderNav);
    }

    addTouchEvents()
    {
        let startX,
            endX;

        this.parentEl.addEventListener('pointerdown',e =>
        {
            if(e.pointerType && (e.pointerType === 'touch' || e.pointerType === 'pen'))
            {
                startX = e.pageX;
                endX = startX;
            }
        });

        this.parentEl.addEventListener('pointermove',e =>
        {
            if(e.pointerType && (e.pointerType === 'touch' || e.pointerType === 'pen'))
            {
                endX = e.pageX;
            }
        });

        this.parentEl.addEventListener('pointerup',e =>
        {
            if(e.pointerType && (e.pointerType === 'touch' || e.pointerType === 'pen'))
            {
                // prev
                if(startX - endX < -75 && this.activeSlideNo > 1)
                {
                    this.move('', '', 'prev');
                    this.autoscroll = false;
                }
                // next
                else if(startX - endX > 75 && this.activeSlideNo < this.slideCount)
                {
                    this.move('', '', 'next');
                    this.autoscroll = false;
                }
            }
        });
    }

    move(e, el, f)
    {
        if(this.moving === false)
        {
            this.moving = true;

            let movePosX = 0,
                offsetX = 0,
                offsetX2 = 0;

            const elStyles = window.getComputedStyle(this.activeSlide);

            // Gallery in Lightbox
            if(this.moveEl.classList.contains('slider-img-gallery'))
            {
                offsetX = parseInt(elStyles.getPropertyValue('padding-left'));
            }
            else if(this.moveEl.classList.contains('slider-img-landscape'))
            {
                // width less than 1800
                if(parseInt(elStyles.getPropertyValue('margin-right')) > 0)
                {
                    offsetX = parseInt(elStyles.getPropertyValue('margin-right'));
                    offsetX2 = offsetX * 2 - 70;
                }
                else
                {
                    offsetX = parseInt(elStyles.getPropertyValue('margin-left'));
                }
            }
            else if(this.moveEl.classList.contains('slider-img-menu'))
            {
                offsetX = parseInt(elStyles.getPropertyValue('padding-left'));
            }

            if(f === 'prev' && this.activeSlideNo > 1)
            {
                this.activeSlideNo -= 1;
            }
            else if(f === 'next' && this.activeSlideNo < this.slideCount)
            {
                this.activeSlideNo += 1;
            }
            else
            {
                if(el.classList.contains('slider-item') &&
                   el.getBoundingClientRect()['left'] > 0 &&
                   el.getBoundingClientRect()['left'] + el.getBoundingClientRect()['width'] < Display.x)
                {
                    this.moving = false;
                    return false;
                }
                else
                {
                    this.autoscroll = false;
                    this.activeSlideNo = parseInt(el.dataset.no);
                }
            }

            if(this.activeSlideNo === 1)
            {
                offsetX2 = 0;
            }

            movePosX = (Display.device === 'smartphone' || Display.device === 'tablet' && Display.orientation === 'portrait')
                ? (this.activeSlideNo - 1) * this.activeSlide.getBoundingClientRect()['width'] * -1
                : ((this.activeSlideNo - 1) * (this.activeSlide.getBoundingClientRect()['width'] -
                  parseInt(elStyles.getPropertyValue('padding-left')) + offsetX) * -1) + offsetX2;

            this.sliderNav.querySelector('li.active').classList.remove('active');
            this.sliderNav.querySelector('li[data-no="' + this.activeSlideNo + '"]').classList.add('active');
            this.activeSlide.classList.remove('active');
            this.activeSlide = this.moveEl.querySelector('.slider-item[data-no="' + this.activeSlideNo + '"]');
            this.activeSlide.classList.add('active');
            this.moveEl.style.transform = 'translateX(' + movePosX.toString() + 'px)';

            setTimeout(() =>
            {
                this.moving = false;
            },750);
        }
    }

    autoscrollNow()
    {
        if(this.autoscroll === true)
        {
            if(this.activeSlideNo === 1)
            {
                this.autoscrollDirection = 'next';
            }
            else if(this.activeSlideNo === this.slideCount)
            {
                this.autoscrollDirection = 'prev';
            }

            this.move('', '', this.autoscrollDirection);

            setTimeout(() => {
                this.autoscrollNow();
            }, this.autoscrollDelay);
        }
    }

    static stop_autoscroll(el)
    {
        const mySlider = el.closest('.autoscroll-slider');
        if(mySlider)
        {
            const mySliderNo = parseInt(mySlider.dataset.sliderNo);
            Basic.sliders[mySliderNo].autoscroll = false;
        }

    }
}